import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { LocalStorageService } from './localStrorage.service';
@Injectable()
export class InterceptorService implements HttpInterceptor {

    constructor() {}

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const session: any = LocalStorageService.getSession();

        if (session && !request.headers.get('Authorization')) {
            const headers = {
                'Authorization': session.token
            };
            request = request.clone({
                setHeaders: headers
            });
        }
        return next.handle(request);
    }
}